import { Helmet } from "react-helmet-async";

type TProps = {
  titleText: string;
  metaDescription: string;
  property?: string;
};

const AppHelmet = (props: TProps) => {
  const { titleText, metaDescription } = props;

  return (
    <Helmet>
      <title>{titleText}</title>
      <meta
        name="description"
        property="og:description"
        content={metaDescription}
      />
    </Helmet>
  );
};

export default AppHelmet;
